import { $showAuthModal } from '~/lib/stores/authModal';

/**
 * What a stay-on-page route shows while its visitor signs in. The auth modal
 * is already open on top of it; this is the page underneath — and the way back
 * into the modal if it gets closed.
 */
export default function SignInHold() {
  return (
    <div className="ui-root min-h-dvh bg-page flex items-center justify-center p-5 sm:p-8">
      <div className="w-full max-w-[440px] text-center">
        <div className="ui-caption text-accent mb-3">Dunea Desktop</div>
        <h1 className="ui-serif text-[32px] sm:text-[40px] leading-[1.05] text-primary m-0 mb-3">
          Sign in to <span className="italic text-accent">continue</span>
        </h1>
        <p className="text-[13.5px] text-secondary leading-relaxed mb-8">
          Sign in to your Dunea account, then authorize the desktop app on this page.
        </p>
        <button className="ui-btn-accent w-full !py-3 !text-[14px]" onClick={() => $showAuthModal.set(true)}>
          Sign in
        </button>
      </div>
    </div>
  );
}
